import { useState, useEffect } from "react";
import { LOYALTY_API_BASE } from "../constants";
import { loyaltyFetch } from "./loyaltyFetch";

/**
 * GET /admin/customer-entitlements/ui-catalog — règles machine-readable (libellés, transitions, endpoints).
 */
export function useCustomerEntitlementsCatalog(brandName) {
    const [catalog, setCatalog] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!brandName) {
            setCatalog(null);
            return;
        }
        let cancelled = false;
        setLoading(true);
        loyaltyFetch(`${LOYALTY_API_BASE}/admin/customer-entitlements/ui-catalog`, {
            headers: { "X-Brand": brandName },
        })
            .then(async (res) => {
                const data = res.ok ? await res.json().catch(() => null) : null;
                if (!cancelled) setCatalog(data);
            })
            .catch(() => { if (!cancelled) setCatalog(null); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [brandName]);

    const statusLabels = catalog?.coupon_status_labels
        || catalog?.status_labels
        || catalog?.statuses
        || null;

    const rewardStatusLabels = catalog?.reward_status_labels || statusLabels;

    const couponTransitions = catalog?.coupon_admin_transitions
        || catalog?.allowed_admin_transitions
        || catalog?.transitions
        || null;

    const badges = catalog?.badges || catalog?.ui_badges || null;
    const endpoints = catalog?.endpoints || null;
    const hints = catalog?.hints || catalog?.ui_hints || null;

    return {
        catalog,
        statusLabels,
        rewardStatusLabels,
        couponTransitions,
        badges,
        endpoints,
        hints,
        loading,
    };
}
